import React from 'react'

import CarouselStories from './CarouselStories'
import SingleStory from './SingleStory'

import useLineItemDetails from '../../../hooks/useLineItemDetails'

const StoriesForm = ({ formik, showError, setShowError, isStepFieldsValid, campaignObjective }) => {
  const { isCarouselAdAllowed } = useLineItemDetails()

  return isCarouselAdAllowed ? (
    <CarouselStories
      formik={formik}
      showError={showError}
      setShowError={setShowError}
      isStepFieldsValid={isStepFieldsValid}
      campaignObjective={campaignObjective}
    />
  ) : (
    <SingleStory
      formik={formik}
      showError={showError}
      setShowError={setShowError}
      isStepFieldsValid={isStepFieldsValid}
    />
  )
}

export default StoriesForm
